import * as React from "react";
import { useAuth, logout } from "../../AuthContext";
import "./Style.scss";

/**
 * Token count down Component
 */
export const CountDownTimer: React.FC = () => {
  const { user } = useAuth();
  const [timeLeft, setTimeLeft] = React.useState<number | null>(null);

  /**
     * To update the timer
     */
  React.useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (user?.expiration) {
      const updateTimer = (): void => {
        const now = Date.now() / 1000;
        const timeLeft = (user?.expiration as number) - now;
        setTimeLeft(timeLeft > 0 ? timeLeft : 0);
      };
      updateTimer();
      intervalId = setInterval(updateTimer, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [user?.expiration]);
  if (timeLeft === null) return null;

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = Math.floor(timeLeft % 60);

  // Custom class
  const className = timeLeft < 300 ? "ebt-timer-blink" : "ebt-timer";

  if (timeLeft === 0) {
    logout();
  }

  return (
    <div
      className={className}
      data-testid="feasibility-token-time"
      title="Session Expiry Time left"
    >
      <span className="ebt-timer-part">
        {String(hours).padStart(2, "0")} : {String(minutes).padStart(2, "0")} : {String(seconds).padStart(2, "0")}
      </span>
    </div>
  );
};
